<template>
  <div class="plan-type-switcher-wrapper">
    <div class="plan-type" :class="{ active: monthly }">
      Месяц
    </div>
    <label class="plan-type-switcher">
      <input type="checkbox" :checked="!monthly" name="switcher" @change="onSwitch">
      <span class="plan-type-switcher-control" />
    </label>
    <div class="plan-type" :class="{ active: !monthly }">
      Год
    </div>
    <div class="discount">
      Скидка 20%
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanTypeSwitcher',
  data() {
    return {
      monthly: false,
    }
  },
  methods: {
    onSwitch() {
      this.monthly = !this.monthly;

      this.$emit('switched', this.monthly);
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";

$toggle-background-color: #3b37ec;
$switch-color: white;
$toggle-width: 40px;
$toggle-height: 20px;
$toggle-gutter: 2px;
$toggle-radius: 50%;
$switch-speed: 0.15s;
$switch-ease: ease-in;

$toggle-radius: $toggle-height / 2;
$switch-size: $toggle-height - ($toggle-gutter * 2);

.plan-type-switcher-wrapper {
  display: flex;

  .plan-type {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #333334;
  }

  .discount {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #ff5605;
    margin-left: 20px;
  }
}

.plan-type-switcher {
  margin: 0 10px;
  display: block;
  position: relative;
  padding-left: $toggle-width;
  cursor: pointer;
  font-size: 22px;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ .plan-type-switcher-control {
    background-color: $toggle-background-color;

    &::after {
      left: $toggle-width - $switch-size - $toggle-gutter;
    }
  }

  .plan-type-switcher-control {
    position: absolute;
    top: 0;
    left: 0;
    height: $toggle-height;
    width: $toggle-width;
    border-radius: $toggle-radius;
    background-color: $toggle-background-color;

    &::after {
      content: '';
      position: absolute;
      left: $toggle-gutter;
      top: $toggle-gutter;
      width: $switch-size;
      height: $switch-size;
      border-radius: $toggle-radius;
      background: $switch-color;
      transition: left $switch-speed $switch-ease;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .plan-type-switcher-wrapper {
    .plan-type {
      font-size: 12px;
    }

    .discount {
      font-size: 12px;
    }
  }

  .plan-type-switcher {
    margin: 0 15px 0 10px;
  }
}
</style>
